import { Mail } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { FooterSocial } from "@/components/FooterSocial";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-alabaster">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 sm:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="font-serif text-3xl sm:text-4xl leading-tight">
              Forever <span className="italic text-gold-light">linked.</span>
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-alabaster/50">
              Permanent bracelets and anklets, welded with intention. One spark, one circle,
              one story that never comes off.
            </p>
            <button
              data-testid="footer-book-button"
              onClick={() => scrollToId("booking")}
              className="mt-8 rounded-full bg-gold text-white px-7 py-3.5 text-sm font-medium hover:bg-gold-dark transition-colors duration-300"
            >
              Book Your Weld
            </button>
          </div>
          <div className="lg:col-span-3">
            <p className="text-[10px] font-mono uppercase tracking-[0.28em] text-gold-light mb-5">Reach the Studio</p>
            <a
              data-testid="contact-email-link"
              href="mailto:booking@faithfullylinked.app"
              className="inline-flex items-center gap-2.5 text-sm text-alabaster/80 hover:text-gold-light transition-colors duration-300"
            >
              <Mail size={15} className="text-gold-light" />
              booking@faithfullylinked.app
            </a>
            <p className="mt-5 text-sm text-alabaster/50 leading-relaxed">
              By appointment only<br />Tuesday – Saturday
            </p>
          </div>
          <FooterSocial />
        </div>
        <div className="mt-16 pt-8 border-t border-alabaster/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-alabaster/40">© 2026 Faithfully Linked. All rights reserved.</p>
          <p className="text-[10px] font-mono uppercase tracking-[0.28em] text-alabaster/30">
            Welded with intention
          </p>
        </div>
      </div>
    </footer>
  );
}
